module.exports = __webpack_public_path__ + "static/media/face1.42d41e61.jpg";